/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_Weather_LoadingInputs */

const en_ui_color_by_reason_weather_loading = /** @type {(inputs: Ui_Color_By_Reason_Weather_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading weather…`)
};

const de_ui_color_by_reason_weather_loading = /** @type {(inputs: Ui_Color_By_Reason_Weather_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wetter wird geladen…`)
};

/**
* | output |
* | --- |
* | "Loading weather…" |
*
* @param {Ui_Color_By_Reason_Weather_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_weather_loading = /** @type {((inputs?: Ui_Color_By_Reason_Weather_LoadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_Weather_LoadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_weather_loading(inputs)
	return de_ui_color_by_reason_weather_loading(inputs)
});